import Button from "../../../componentes/button/button";

function Campo({ label, value, colSpan }) {
    return (
        <div className={`col-span-${colSpan || 1}`}>
            <div className="text-xs text-muted-foreground">{label}</div>
            <div className="font-medium text-foreground">{value || "-"}</div>
        </div>
    );
}

function VisualizarEscalaDeRota({ escala, onHide, onEdit }) {

    return (
        <div className="flex flex-col gap-5 p-4 w-full">
            <div className="p-1 grid grid-cols-2 md:grid-cols-6 gap-3">

                <Campo label="Filial" value={escala?.filialNome} />
                <Campo label="Carga" value={escala?.carga} />
                <Campo label="Veículo" value={
                    <label>
                        {escala?.veiculoPlaca}
                        <span className="text-muted-foreground font-base text-xs mx-1">{escala?.veiculoCodigoSolar}</span>
                    </label>}
                    colSpan={1}
                />
                <Campo label="Crachá" value={escala?.cracha} />
                <Campo label="Transporte" value={escala?.transporte} />
                <Campo label="Tipo de Rota" value={escala?.tipoRota} />
                <Campo label="Motorista" value={escala?.motoristaNome} colSpan={2} />
                <Campo label="Auxiliares" value={
                    <div className="flex flex-col">
                        {escala?.auxiliares?.map((aux, index) => (
                            <label key={aux + index}>
                                {index + 1} - {aux.nome}
                            </label>
                        ))}
                    </div>
                } colSpan={2} />
                <Campo label="Área" value={escala?.area} colSpan={2} />
                <Campo label="Total Entregas" value={escala?.totalEntregas} />
                <Campo label="Volume" value={escala?.volume} />
                <Campo label="cubos" value={escala?.cubos} />
                <Campo label="Capacidade de Cubos" value={escala?.capCubos} />
                <Campo label="Distância Planejada" value={escala?.distanciaPlanejada + " KM"} />
                <Campo label="Ocupação" value={escala?.ocupacao + "%"} />

            </div>
            {/* Botões */}
            <div className="flex justify-end gap-3 mt-4 border-t border-border items-end pt-3">
                {/*
                 <Button
                    label="Editar"
                    variant="white"
                    iconLeft="fa fa-edit"
                    onClick={() => onEdit?.()}
                /> 
                */}
                <Button
                    label="Fechar"
                    variant="gray"
                    iconLeft="fa fa-times"
                    onClick={() => onHide?.()}
                />
            </div>

        </div>
    );
}

export default VisualizarEscalaDeRota;
